// @wojtekmaj/react-daterange-picker v3 ships CommonJS with `exports.default`; Vite's ESM
// interop can hand us the module object instead of the component (React error #130).
import * as DateRangePickerModule from '@wojtekmaj/react-daterange-picker';

const resolve = (m) => (m && typeof m === 'object' && 'default' in m ? resolve(m.default) : m);

const BaseDateRangePicker = resolve(DateRangePickerModule);

// The library's calendar/clear triggers are icon-only buttons; give them accessible names by
// default (callers can still override any of these props).
export default function DateRangePicker(props) {
  return (
    <BaseDateRangePicker
      calendarAriaLabel="Open date range calendar"
      clearAriaLabel="Clear date range"
      dayAriaLabel="Day"
      monthAriaLabel="Month"
      yearAriaLabel="Year"
      {...props}
    />
  );
}
